export default __webpack_public_path__ + "static/media/ClockShowHideSeconds.5090717d.mp4";